import type { StyleProp, ViewStyle } from 'react-native';

export type TextAreaProps = {
  label: string;
  value: string;
  onChange: (html: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  maxLength: number;
  fieldLabel?: string;
  requestId?: string;
  isOnline: boolean;
  requestSection: string;
  error?: string;
  disabled?: boolean;
  /** When true, omit the built-in label (caller renders FieldLabelWithInfo, etc.). */
  hideLabel?: boolean;
  testID?: string;
  containerStyle?: StyleProp<ViewStyle>;
  /** Rich HTML form key (e.g. oppProjectDescription) for create-flow attachment flush. */
  transportFieldKey?: string;
};

export function parseTextAreaRequestId(
  requestId?: string | number,
): number | null {
  if (requestId == null || requestId === '') {
    return null;
  }
  const trimmed = String(requestId).trim();
  if (!/^\d+$/.test(trimmed)) {
    return null;
  }
  const parsed = Number.parseInt(trimmed, 10);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
}
